import {Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {DirectoryContentsList} from 'features/layout/CommonPage/panels/TransportPanel/components/common/DirectoryContentsList';
import React from 'react';
import {Trans} from 'react-i18next';
import {ITestSharefileResult} from 'types/TestSharefileResult';

type Props = {
   loading?: boolean;
   onlyLables?: boolean;
   state?: {
      dirPath: ITestSharefileResult['dirPath'];
      msg?: ITestSharefileResult['msg'];
      dirListingReceived?: ITestSharefileResult['dirListingReceived'];
      directoryContents: ITestSharefileResult['directoryContents'];
   };
   error?: Response;
};

export const ResultContent = ({onlyLables, error, state, loading}: Props) => {
   const {t} = useTranslation();
   const {dirPath, msg, dirListingReceived, directoryContents} = state || {};
   const isDirListAvailable = dirListingReceived || (directoryContents && directoryContents.length);
   return (
      <>
         {onlyLables ? null : (
            <>
               {dirPath ? (
                  <Typography>
                     <Trans>Default directory is {dirPath}</Trans>
                  </Typography>
               ) : null}
               {msg ? <Typography>{msg}</Typography> : null}
               <br />
               {isDirListAvailable || loading ? (
                  <>
                     <DirectoryContentsList data={directoryContents!} />
                  </>
               ) : (
                  <Typography>
                     {t('Directory listing was not received from the server.')}
                  </Typography>
               )}
            </>
         )}
         {error ? <pre>{JSON.stringify(error)}</pre> : null}
      </>
   );
};
